let refreshToken: string | null = null
let accessToken: string | null = null
let idToken: string | null = null
let expiry: number | null = null

export default class CognitoTokens {
  public static get refresh() {
    return refreshToken
  }

  public static get access() {
    if (CognitoTokens.expired) {
      return null
    }
    return accessToken
  }

  public static get id() {
    if (CognitoTokens.expired) {
      return null
    }
    return idToken
  }

  public static get expired() {
    return expiry === null || expiry <= Date.now()
  }

  public static store(data: Record<string, string | number>) {
    refreshToken = data.refresh_token as string
    accessToken = data.access_token as string
    idToken = data.id_token as string
    expiry = Date.now() + (data.expires_in as number) * 1000
  }

  public static logout() {
    refreshToken = null
    accessToken = null
    idToken = null
    expiry = null
  }
}
